import EmojiRatingPage from "@components/EmojiRatingPage"

export default function PetsConfidenceLevelPage() {
  return (
    <EmojiRatingPage
      translationKey="petsConfidenceLevel"
      leftLabelKey="leftLabel"
      rightLabelKey="rightLabel"
    />
  )
}
